 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Account":"Account","Admin/Dashboard":"Admin/Dashboard","Admin/FavPages/FavPages":"Admin/FavPages/FavPages","Admin/FavPages/FavPage~FaveItButton~Home":"Admin/FavPages/FavPage~FaveItButton~Home","Admin/FavPages/FavPage":"Admin/FavPages/FavPage","FaveItButton":"FaveItButton","Home":"Home","Admin/Main":"Admin/Main","Admin/Users/Users":"Admin/Users/Users","Contact":"Contact","Export":"Export","FavesByCountryName.":"FavesByCountryName.","Press":"Press","Privacy":"Privacy","TermConditions":"TermConditions","User/Auth/ConfirmAccountView":"User/Auth/ConfirmAccountView","User/Auth/ForgotPassword":"User/Auth/ForgotPassword","User/Auth/Login":"User/Auth/Login","User/Auth/Register":"User/Auth/Register","User/Auth/ResetPassword":"User/Auth/ResetPassword","User/Auth/SocialLogin":"User/Auth/SocialLogin","User/Dashboard":"User/Dashboard","User/Main":"User/Main","about":"about"}[chunkId]||chunkId) + "." + {"Account":"1b1752ce","Admin/Dashboard":"b754bb1f","Admin/FavPages/FavPages":"95964329","Admin/FavPages/FavPage~FaveItButton~Home":"1a392c7d","Admin/FavPages/FavPage":"066deceb","FaveItButton":"f2e4bf55","Home":"0ba58a66","Admin/Main":"e76e39f9","Admin/Users/Users":"3b032da6","Contact":"0623e74b","Export":"ac204f45","FavesByCountryName.":"f616e824","Press":"28b1a70f","Privacy":"8c67c790","TermConditions":"9bc09081","User/Auth/ConfirmAccountView":"ff9cbc29","User/Auth/ForgotPassword":"e746a700","User/Auth/Login":"a4d69265","User/Auth/Register":"050d0d8f","User/Auth/ResetPassword":"057085ff","User/Auth/SocialLogin":"9dda4108","User/Dashboard":"0c2de1ad","User/Main":"156ffbea","about":"b26995f2","chunk-2a6a794e":"335bfb8e","chunk-7d99c764":"216caeb8","chunk-fe2a19de":"84e749d7","chunk-27ee0ecc":"33abb390","chunk-5351101c":"f5f0b254"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Account":1,"Admin/Dashboard":1,"Admin/FavPages/FavPages":1,"Admin/FavPages/FavPage~FaveItButton~Home":1,"Admin/FavPages/FavPage":1,"FaveItButton":1,"Home":1,"Admin/Main":1,"Admin/Users/Users":1,"Contact":1,"Export":1,"User/Auth/ConfirmAccountView":1,"User/Auth/ForgotPassword":1,"User/Auth/Login":1,"User/Auth/Register":1,"User/Auth/ResetPassword":1,"User/Auth/SocialLogin":1,"User/Dashboard":1,"User/Main":1,"about":1,"chunk-2a6a794e":1,"chunk-7d99c764":1,"chunk-fe2a19de":1,"chunk-27ee0ecc":1,"chunk-5351101c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Account":"Account","Admin/Dashboard":"Admin/Dashboard","Admin/FavPages/FavPages":"Admin/FavPages/FavPages","Admin/FavPages/FavPage~FaveItButton~Home":"Admin/FavPages/FavPage~FaveItButton~Home","Admin/FavPages/FavPage":"Admin/FavPages/FavPage","FaveItButton":"FaveItButton","Home":"Home","Admin/Main":"Admin/Main","Admin/Users/Users":"Admin/Users/Users","Contact":"Contact","Export":"Export","FavesByCountryName.":"FavesByCountryName.","Press":"Press","Privacy":"Privacy","TermConditions":"TermConditions","User/Auth/ConfirmAccountView":"User/Auth/ConfirmAccountView","User/Auth/ForgotPassword":"User/Auth/ForgotPassword","User/Auth/Login":"User/Auth/Login","User/Auth/Register":"User/Auth/Register","User/Auth/ResetPassword":"User/Auth/ResetPassword","User/Auth/SocialLogin":"User/Auth/SocialLogin","User/Dashboard":"User/Dashboard","User/Main":"User/Main","about":"about"}[chunkId]||chunkId) + "." + {"Account":"ead896eb","Admin/Dashboard":"eba08803","Admin/FavPages/FavPages":"3eae0bac","Admin/FavPages/FavPage~FaveItButton~Home":"fde1bbea","Admin/FavPages/FavPage":"fd7e9dc9","FaveItButton":"2fa57784","Home":"81d1f067","Admin/Main":"764c9a81","Admin/Users/Users":"2e022b1a","Contact":"07b5fe33","Export":"8096c48d","FavesByCountryName.":"31d6cfe0","Press":"31d6cfe0","Privacy":"31d6cfe0","TermConditions":"31d6cfe0","User/Auth/ConfirmAccountView":"35e7fa89","User/Auth/ForgotPassword":"c479204b","User/Auth/Login":"6d089aea","User/Auth/Register":"bec1bca7","User/Auth/ResetPassword":"ff4bbec5","User/Auth/SocialLogin":"86f0a797","User/Dashboard":"5dccb0aa","User/Main":"1a9fe7a1","about":"1a9fe7a1","chunk-2a6a794e":"1a8918b6","chunk-7d99c764":"c3cbddd8","chunk-fe2a19de":"9ce8695c","chunk-27ee0ecc":"5b1bd602","chunk-5351101c":"85f0c9db"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
